var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00878906H513V341.991H0V-0.00878906Z",
    fill: "#D01920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.979 89.209H368.022V252.778H144.979V89.209Z",
    fill: "#017C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.038 219.314C257.349 219.314 235.712 197.677 235.712 170.987C235.712 144.297 257.348 122.661 284.038 122.661C292.36 122.661 300.189 124.765 307.026 128.47C296.302 117.982 281.635 111.51 265.451 111.51C232.603 111.51 205.973 138.138 205.973 170.987C205.973 203.836 232.603 230.465 265.451 230.465C281.636 230.465 296.302 223.992 307.026 213.505C300.19 217.211 292.361 219.314 284.038 219.314Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/MV.da098fdcade4a85360fc5736da481cf2.svg";
export { ForwardRef as ReactComponent };